/**
 * @file: 标签显示判断
 * @author: xiaolong.huang@dmall.com
 */

import Config from '../../config/index';

export function tagIsChecked(): boolean {
    let tagChecked: boolean = Config.getGlobalConfig('tagChecked');

    return tagChecked;
}
